export default __webpack_public_path__ + "static/media/m_use_action_xw.b210866f.png";